document.addEventListener("DOMContentLoaded", () => {
  if (!window.gsap || !window.ScrollTrigger) return;
  gsap.registerPlugin(ScrollTrigger);

  if (!document.body.classList.contains("page-index")) return;

  const header = document.querySelector(".header-wrapper");
  const hero = document.querySelector(".page-index main > section:first-of-type");
  if (!header || !hero) return;

  // ✅ Si recargan scrolleado, quita la clase desde el inicio
  if (window.scrollY > 0) header.classList.remove("active-hero");

  ScrollTrigger.create({
    trigger: hero,
    start: "top top",
    end: "50% top",
    onEnter: () => header.classList.add("active-hero"),
    onLeave: () => header.classList.remove("active-hero"),
    onEnterBack: () => header.classList.add("active-hero"),
    //markers:true,
  });

});


document.addEventListener("DOMContentLoaded", () => {
  if (!window.gsap || !window.ScrollTrigger) return;
  gsap.registerPlugin(ScrollTrigger);

    const HEADINGS = `
    .header-between-text p,
  .page-index section .rich-text .rich-text__blocks p, 
  .multicolumn .title, 
  .multicolumn-list h3, 
  .page-index .collection-list .card-wrapper .card h2,
  .page-page section:first-of-type .rich-text .rich-text__blocks h2,
  .image-with-text__heading,
  .product__title h1,
  .page-product .rich-text__blocks h2,
  .product__custom-heading,
  .page-collection .rich-text__wrapper h2,
  .page-hecho .banner .banner__box .banner__heading,
  .page-hecho .rich-text__blocks h2,
  .page-hecho section:nth-of-type(6) .multicolumn .multicolumn-list .rte p,
  .page-hecho section:nth-of-type(2) .rich-text .rich-text__blocks p,
  .page-acerca-hecho .rich-text__blocks h2
  `;

  function splitHeading(el) {
    // Evita re-split (muy importante en Shopify)
    if (el.dataset.split === "true") return;
    el.dataset.split = "true";

    // Solo texto plano (no toca spans/links internos)
    const text = el.textContent.trim().replace(/\s+/g, " ");
    el.setAttribute("aria-label", text);

    const words = text.split(" ");

    el.innerHTML = words
      .map(
        (word) => `
        <span class="split-word-wrap" aria-hidden="true">
          <span class="split-word">${word}</span>
        </span>
      `
      )
      .join(" ");
  }

  function animateHeading(el) {
    const words = el.querySelectorAll(".split-word");

    gsap.set(HEADINGS, {
  opacity: 1
});

    gsap.fromTo(
      words,
      {
        y: "1.2em",
      },
      {
        y: "0em",
        duration: 1.1,
        ease: "power3.out",
        stagger: 0.08,
        scrollTrigger: {
          trigger: el,
          start: "top 90%",
          toggleActions: "play none none none"
        }
      }
    );
  }

  function initHeadings(scope = document) {
    scope.querySelectorAll(HEADINGS).forEach((heading) => {
      splitHeading(heading);
      animateHeading(heading);
    });
  }

  // Inicial
  initHeadings();

  // Shopify Theme Editor support
  document.addEventListener("shopify:section:load", (e) => {
    initHeadings(e.target);
  });
});